
export class UpdateInventoryReturnDataIds {
    returnToMayaveProductIdList: number[] = [];
}
